import React, { useState, useEffect, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const defaultValue = {};

const BreakpointContext = createContext(defaultValue);

const queries = {
  smMobile: '(max-width: 319px)',
  mdMobile: '(max-width: 479px)',
  stdMobile: '(max-width: 767px)',
  tablet: '(max-width: 991px)',
  laptop: '(max-width: 1199px)',
  desktop: '(min-width: 1679px)',
  portrait: '(orientation: portrait)',
  landscape: '(orientation: landscape)',
};

const BreakpointProvider = ({ children }) => {
  BreakpointProvider.propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  };

  const [queryMatch, setQueryMatch] = useState({});

  useEffect(() => {
    const mediaQueryLists = {};
    const keys = Object.keys(queries);
    let isAttached = false;

    const handleQueryListener = () => {
      const updatedMatches = keys.reduce((acc, media) => {
        acc[media] = !!(
          mediaQueryLists[media] && mediaQueryLists[media].matches
        );
        return acc;
      }, {});
      setQueryMatch(updatedMatches);
    };

    if (window && window.matchMedia) {
      const matches = {};
      keys.forEach((media) => {
        if (typeof queries[media] === 'string') {
          mediaQueryLists[media] = window.matchMedia(queries[media]);
          matches[media] = mediaQueryLists[media].matches;
        } else {
          matches[media] = false;
        }
      });
      setQueryMatch(matches);
      isAttached = true;
      keys.forEach((media) => {
        if (typeof queries[media] === 'string') {
          mediaQueryLists[media].addListener(handleQueryListener);
        }
      });
    }

    return () => {
      if (isAttached) {
        keys.forEach((media) => {
          if (typeof queries[media] === 'string') {
            mediaQueryLists[media].removeListener(handleQueryListener);
          }
        });
      }
    };
  }, [queries]);

  return (
    <BreakpointContext.Provider value={queryMatch}>
      {children}
    </BreakpointContext.Provider>
  );
};

function useBreakpoint() {
  const context = useContext(BreakpointContext);

  return context;
}

export { useBreakpoint, BreakpointProvider };
